// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseInput_container__2_GB4","dark":"BaseInput_dark__3MieS","light":"BaseInput_light__UAO_4","content":"BaseInput_content__265xr","input":"BaseInput_input__2LOio"};